module.exports = __webpack_public_path__ + "48eab0f720a42b95bf2001ad398085ef.jpg";